import React, { PropsWithChildren, useEffect, useState } from 'react';
import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { DraggableItem } from './DraggableItem';
import { selectOnlyTaskById, useKanbanEventStore } from '../store';

type SortableItemProps = {
  columnId: UniqueIdentifier;
  id: UniqueIdentifier;
  index: number;
  disabled?: boolean;
};

export const SortableItem = ({ disabled, id, index, children, columnId }: PropsWithChildren<SortableItemProps>) => {
  const task = useKanbanEventStore(selectOnlyTaskById(id as number));
  const { setNodeRef, listeners, isDragging, transform, transition } = useSortable({
    id,
    data: {
      columnId,
      taskStatus: task?.status,
      queueId: task?.queueId,
    },
  });
  const mounted = useMountStatus();
  const mountedWhileDragging = isDragging && !mounted;

  return (
    <DraggableItem
      dragging={isDragging}
      fadeIn={mountedWhileDragging}
      index={index}
      listeners={disabled ? undefined : listeners}
      ref={disabled ? undefined : setNodeRef}
      transform={transform}
      transition={transition}
    >
      {children}
    </DraggableItem>
  );
};

const useMountStatus = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), 500);

    return () => clearTimeout(timeout);
  }, []);

  return isMounted;
};
